/** Select the portal rollout mode before the router or any store evaluates. */
import { configureAuthMode } from '@claimshield/shared'

if (import.meta.env.CLAIMSHIELD_PORTAL_AUTH_MODE === 'identity') {
  configureAuthMode('portal-identity')
  const url = new URL(window.location.href)
  const redeemingViewAs = url.pathname === '/view-as/redeem'
  for (const key of ['code', 'state', 'session_state', 'iss', 't']) {
    if (key !== 'code' || !redeemingViewAs) url.searchParams.delete(key)
  }
  if (url.href !== window.location.href) {
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash)
  }
}
